import { AppSettings } from './app.settings'
export class ProductSettings {
    public static PRODUCT_DETAILS = `${AppSettings.BASE_URL}/api/product/:id`;
    public static PRODUCT_TOP = `${AppSettings.BASE_URL}/api/product/top`;
    public static PRODUCTS_HREFLANG = `${AppSettings.BASE_URL}/api/product/href/:id`;
    public static PRODUCTS_CITY = `${AppSettings.BASE_URL}/api/product/city/:id`;
    public static PRODUCTS_TOP_CITY = `${AppSettings.BASE_URL}/api/product/city/:id/top`;
    public static PRODUCTS_SPOTLIGHT = `${AppSettings.BASE_URL}/api/product/city/spotlight/:id`;
    public static PRODUCT_ADD_CART = `${AppSettings.BASE_URL}/api/transaction/reserveTransaction`;
    public static PRODUCT_ALL_STOPS = `${AppSettings.BASE_URL}/api/product/:id/stops`;
}